import { isUndefined } from 'util';
import { Observable } from 'rxjs';
import { read, utils as xlsxUtils, write as XLSXWrite } from 'xlsx';
import { saveAs } from 'file-saver';
import { SheetHeaderModal } from './sheet-header-modal';
import { SheetModel } from './sheet-model';
import { SheetReadResult } from './sheet-read-result';

export class NecSheetService {

  constructor() {
  }

  /**
   * å¯¼åºexcel
   */
  exportExcel(excelModel: SheetModel, type: any, fileName: string, cellMerges?: any) {
    let json = excelModel.sheet;
    // æ·»å è¡¨æ ¼è¡¨å¤´
    json.unshift([]);
    let keyMap = []; // è·åkeys
    json[1].forEach(item => {
      for (let k in item) {
        keyMap.push(k);
        let head = Object.create(null);
        head[k] = k;
        json[0].push(head);
      }
    });
    // æ·»å è¡¨æ ¼è¡æ°æ®
    let tmpdata = [];
    let _this=this;
    json.map(function (v, i) {
      return keyMap.map((k, j) => {
        return Object.assign({}, {
          v: v[j][k],
          position: (j > 25 ? _this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
        });
      });
    }).reduce((prev, next) => {
      // çæåæ 
      return prev.concat(next);
    }).forEach((v) => {
      tmpdata[v.position] = {
        v: v.v
      };
    });
    // ææååæ ¼åæ 
    let outputPos = Object.keys(tmpdata); // è®¾ç½®åºå,æ¯å¦è¡¨æ ¼ä»A1å°D10
    // è¡¨æ ¼è®¾ç½®
    let tmpWB = Object.create(null);
    tmpWB.SheetNames = [excelModel.sheetName]; // ä¿å­çè¡¨æ é¢
    tmpWB.Sheets = Object.create(null);
    tmpWB.Sheets[excelModel.sheetName] = Object.assign({}, tmpdata,
      {
        '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1],
        '!cols': this.getColsWidth(json)
      }
    );
    if (cellMerges && cellMerges.length > 0) {
      let tempMerges = [];
      cellMerges.forEach(function (cell) {
        tempMerges.push({
          s: {// sä¸ºå¼å§
            c: cell.colStart, // å¼å§å
            r: cell.rowStart// å¼å§åå¼èå´
          },
          e: {// eç»æ
            c: cell.colEnd, // ç»æå
            r: cell.rowEnd// ç»æèå´
          }
        });
      });
      tmpWB.Sheets[excelModel.sheetName]['!merges'] = tempMerges;
    }
    // çæblobæ°æ®
    let tmpDown = new Blob([this.s2ab(XLSXWrite(tmpWB, // è¿éçæ°æ®æ¯ç¨æ¥å®ä¹å¯¼åºçæ ¼å¼ç±»å
      {
        bookType: (isUndefined(type) ? 'xlsx' : type),
        bookSST: true,
        type: 'binary'
      }
    ))], {
        type: ''
      }); // åå»ºäºè¿å¶å¯¹è±¡åå¥è½¬æ¢å¥½çå­èæµ
    // ä¿å­blobæ°æ®
    saveAs(tmpDown, fileName + '.' + type);
  }

  exportMultipleExcel(excelModels: SheetModel[], type: any, fileName: string, cellMerges?: any, columnWidth?: number) {
    let tmpWB = {SheetNames: [], Sheets: {}};
    for (let excelModel in excelModels) {
      let json = excelModels[excelModel].sheet;
    // æ·»å è¡¨æ ¼è¡¨å¤´
      json.unshift([]);
      let keyMap = []; // è·åkeys
      json[1].forEach(item => {
        for (let k in item) {
          keyMap.push(k);
          let head = Object.create(null);
          head[k] = k;
          json[0].push(head);
        }
      });
      let tmpdata = [];
      let _this=this;
      json.map(function (v, i) {
        return keyMap.map((k, j) => {
          return Object.assign({}, {
            v: v[j][k],
            position: (j > 25 ? _this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1),
            t: 's'
          });
          
        });
      }).reduce((prev, next) => {
        // çæåæ 
        return prev.concat(next);
      }).forEach((v) => {
        tmpdata[v.position] = {
          t: v.t,
          v: v.v
        };
      });
      // ææååæ ¼åæ 
      let outputPos = Object.keys(tmpdata); // è®¾ç½®åºå,æ¯å¦è¡¨æ ¼ä»A1å°D10
      // è¡¨æ ¼è®¾ç½®
      
      tmpWB.SheetNames.push([excelModels[excelModel].sheetName]); // ä¿å­çè¡¨æ é¢
      tmpWB.Sheets[excelModels[excelModel].sheetName] = (Object.assign({}, tmpdata,
        {
          '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1],
          '!cols': this.getColsWidth(json, columnWidth)
        }
      ));
      if (cellMerges && cellMerges.length > 0) {
        let tempMerges = [];
        cellMerges.forEach(function (cell) {
          tempMerges.push({
            s: {// sä¸ºå¼å§
              c: cell.colStart, // å¼å§å
              r: cell.rowStart,// å¼å§åå¼èå´
            },
            e: {// eç»æ
              c: cell.colEnd, // ç»æå
              r: cell.rowEnd,// ç»æèå´
            }
          });
        });
        tmpWB.Sheets[excelModels[excelModel].sheetName]['!merges'] = tempMerges;
      }
    }
    // çæblobæ°æ®
    let tmpDown = new Blob([this.s2ab(XLSXWrite(tmpWB, // è¿éçæ°æ®æ¯ç¨æ¥å®ä¹å¯¼åºçæ ¼å¼ç±»å
      {
        bookType: (isUndefined(type) ? 'xlsx' : type),
        bookSST: true,
        type: 'binary'
      }
    ))], {
        type: ''
      }); // åå»ºäºè¿å¶å¯¹è±¡åå¥è½¬æ¢å¥½çå­èæµ
    // ä¿å­blobæ°æ®
    saveAs(tmpDown, fileName + '.' + type);
  }
 
  /**
   * å¤æ­æ¯å¦excelæä»¶
   */
  isExcel(file: File): boolean {
    const type = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
    if (type.includes('xlsx') || type.includes('xls')) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * å°æå®çèªç¶æ°è½¬æ¢ä¸º26è¿å¶è¡¨ç¤ºãæ å°å³ç³»ï¼[0-25] -> [A-Z]
   */
  private getCharCol(n: number) {
    let s = '',
      m = 0;
    while (n > 0) {
      m = n % 26 + 1;
      s = String.fromCharCode(m + 64) + s;
      n = (n - m) / 26;
    }
    return s;
  }

  // è®¡ç®åå®½
  private getColsWidth(json, columnWidth?: number) {
    let results = [];
    let columnMap = new Map();
    json.forEach(row => {
      row.forEach((column, index) => {
        for (let k in column) {
          let width;
          if (columnWidth !== undefined) {
            columnMap.set(index,{width: columnWidth});
            continue;
          }
          if (columnMap.has(index)) {
            width = column[k] ? Math.min(column[k].length, 100) : 5;
            if (columnMap.get(index).width < width) {
              width = width < 5 ? 5 : width;
              columnMap.set(index, { width: (width * 2) });
            }
          } else {
            width = column[k] ? Math.min(column[k].length, 100) : 5;
            width = width < 5 ? 5 : width;
            columnMap.set(index, { width: (width * 2) });
          }
        }
      });
    });

    columnMap.forEach((value, key) => {
      results[key] = value;
    });
    return results;
  }

  /**
   * å­ç¬¦ä¸²è½¬å­ç¬¦æµ
   */
  private s2ab(s) {
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

  readXLSX(file): Observable<SheetReadResult> {
    const observable = Observable.create(observer => {
      let reader = new FileReader();
      reader.onload = function (e) {
        let bstr = e.target['result'];
        try {
          let wb = read(bstr, { type: 'binary' });

          let wsname = wb.SheetNames[0];
          let ws = wb.Sheets[wsname];

          let aoa = xlsxUtils.sheet_to_json(ws, { header: 1, raw: false });
          let cols = [];
          for (let i = 0; i < aoa[0]['length']; ++i) {
            cols[i] = new SheetHeaderModal(aoa[0][i]);
          }

          let data = [];
          for (let r = 1; r < aoa.length; ++r) {
            data[r - 1] = {};
            for (let i = 0; i < aoa[r]['length']; ++i) {
              if (aoa[r][i] == null) {
                continue;
              }
              data[r - 1][aoa[0][i]] = aoa[r][i];
            }
          }
          observer.next(new SheetReadResult(cols, data));
          observer.complete();
        } catch (error) {
          observer.error('æä»¶è¯»åå¤±è´¥');
          observer.complete();
        }

      };
      reader.onerror = function () {
        observer.error('æä»¶è¯»åå¤±è´¥');
        observer.complete();
      };

      reader.readAsBinaryString(file);
    });
    return observable;
  }
}
